<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-input v-model="getSysIpLocationList_data.userName" placeholder="请输入用户名" clearable size='small'
                    style="max-width:200px;" />
                <el-input v-model="getSysIpLocationList_data.silIp" placeholder="请输入请求微服务ip" clearable size='small'
                    style="max-width:200px;" />
                <el-input v-model="getSysIpLocationList_data.silProvince" placeholder="请输入归属省" clearable size='small'
                    style="max-width:200px;" />
                <el-input v-model="getSysIpLocationList_data.silCity" placeholder="请输入归属市" clearable size='small'
                    style="max-width:200px;" />
                <el-input v-model="getSysIpLocationList_data.silDistrict" placeholder="请输入归属区" clearable size='small'
                    style="max-width:200px;" />
                <el-button v-click.getSysIpLocationList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
                <el-button @click="Bulksure()" type="success" icon="el-icon-search" size="small"
                    style="margin-left:10px;">导出
                </el-button>
            </el-col>
        </el-row>

        <mytable ref="getSysIpLocationList" :tableColums='tableColums_getSysIpLocationList' api='getSysIpLocationList'
            xupdateapi='updateUser' :height="H - 165">
        </mytable>
        <myform :viewobj='{
            getSysIpLocationListCityCodeUserClick: ["用户ip归属", "el-icon-circle-plus"],
        }' @close='$form("getSysIpLocationListCityCodeUserClick", "reset")'>
            <div style="display: flex;flex-direction:row-reverse;align-items: center;">
                <el-button @click="Bulksure2()" type="success" icon="el-icon-search" size="small"
                    style="margin-left:10px;">导出
                </el-button>
            </div>
            <mytable ref="getSysIpLocationListCityCodeUser" :tableColums='tableColums_getSysIpLocationListCityCodeUser'
                api='getSysIpLocationListCityCodeUser' xupdateapi='updateUser' :height="H - 165">
            </mytable>
            <!-- <hide slot='vtId' /> -->
        </myform>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            theRow:{
                silCityCode: ''
            },
             baseUrl: $Api.baseUrl_online,
            tableColums_getSysIpLocationListCityCodeUser: {
                $selection: false,

                logInstance: ['微服务名称', 130,],
                logTime: ['请求时间', 160,],
                // logMethod: '请求方式',
                // logRawPath: '请求地址',
                logPath: '请求地址',
                // logParams: '请求参数',
                logIp: ['请求ip', 120,],
                logUserName: ['请求人员名称', 120,],
                logRequestTime: ['请求耗时(ms)', 120,],
                silCity: ['ip归属地', 320,],
            },
            theProjectId: '',
            tabs: 1,
            DetailList: '',
            detailShow: false,
            valueDate: '',
            userId: null,
            theProjectId: "",
            theUserProject: "",
            theLogInstanceAll: [
                { id: 1, name: "opportunity", label: "opportunity" },
                { id: 2, name: "appcenter", label: "appcenter" },
                { id: 3, name: "apptask", label: "apptask" },
                { id: 4, name: "trainingmsg", label: "msg" },
                { id: 5, name: "interview", label: "interview" },
                { id: 6, name: "ajtools", label: "ajtools" },
                { id: 7, name: "assetsuse", label: "assetsuse" },
            ],
            logInstance: "",
            tableColums_getSysIpLocationList: {
                $selection: false,

                silIp: ['ip地址', 150,],
                silProvince: ['ip归属省', 120,],
                silCity: ['ip归属市', 120,],
                silDistrict: ['ip归属区', 120,],
                // logMethod: '请求方式',
                // logRawPath: '请求地址',
                silCityCode: '城市编码',
                adcode: '行政区编码',
                pointx: '当前城市中心点经度',
                pointy: '当前城市中心点纬度',

                // logParams: '请求参数',
                silStatus: ['类型', 200, '@v-if: 2:失效 #danger,1:正常#success'],
                createtime: ['创建时间', 160,],
                $operation: [
                    "操作 | fixed:right", 200,
                    this.getSysIpLocationListCityCodeUser && `@text: 查询用户#success
           @click: handleCityCodeUser($row)
          `,],
            },

        };
    },

    watch: {

    },

    methods: {
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Bulksure() {
            const bulkdata = {
                projectId: this.theProjectId,
                silProvince: this.getSysIpLocationList_data.silProvince,
                silIp: this.getSysIpLocationList_data.silIp,
                userName: this.getSysIpLocationList_data.userName,
                silCity: this.getSysIpLocationList_data.silCity,
                silDistrict: this.getSysIpLocationList_data.silDistrict,
            };
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this;
            axios({
                method: "post",
                url:
                    that.baseUrl +
                    "/traininglog/sys-ip-location/exportSysIpLocationList",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    token: A.local("$Usertoken"),
                    projectId: +A.local("$projectId")
                }
            }).then(function (res) {
                if (res.data) {
                    that.loading.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "ip地址.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                }
            });
        },
        Bulksure2() {
            const bulkdata = {
                projectId: this.theProjectId,
                silCityCode: this.theRow.silCityCode,
            };
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this;
            axios({
                method: "post",
                url:
                    that.baseUrl +
                    "/traininglog/sys-ip-location/exportSysIpLocationListCityCodeUser",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    token: A.local("$Usertoken"),
                    projectId: +A.local("$projectId")
                }
            }).then(function (res) {
                if (res.data) {
                    that.loading.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "ip地址.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                }
            });
        },
        async handleCityCodeUser(row) {
            if (!this.theProjectId) {
                this.$message.error("请先选择项目");
                return;
            }
            this.theRow.silCityCode = row.silCityCode;
            const result = await this.getSysIpLocationListCityCodeUser({ projectId: this.theProjectId, silCityCode: row.silCityCode, adcode: row.adcode, pageSize: 0 })
            this.$form("getSysIpLocationListCityCodeUserClick");
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData();
        },
        getData() {
            this.getSysIpLocationList({
                projectId: this.theProjectId,
                userName: this.getSysIpLocationList_data.userName,
                sdlType: this.getSysIpLocationList_data.sdlType,
                sdlInstance: this.getSysIpLocationList_data.sdlInstance,
                sdlIp: this.getSysIpLocationList_data.sdlIp,
                createtimeStart: this.getSysIpLocationList_data.createtimeStart,
                createtimeEnd: this.getSysIpLocationList_data.createtimeEnd,
                currentPage: 1,
            });
        },
        DeailClose() {
            this.detailShow = false;
            this.DetailList = '';
            this.tabs = 1
        },
        handelDetail(row) {
            this.getSysDruidLogDetails({ sdlId: row.sdlId }).result(res => {
                if (row.sdlType == 1) {
                    this.tabs = 3
                }
                this.DetailList = res.data.data;
                this.detailShow = true;
            })
        },
        timeChange(e) {
            if (e) {
                this.getSysIpLocationList_data.createtimeStart = e[0];
                this.getSysIpLocationList_data.createtimeEnd = e[1];
            } else {
                this.getSysIpLocationList_data.createtimeStart = "";
                this.getSysIpLocationList_data.createtimeEnd = "";
            }
            this.getData();
        },

    },

    created() {
        this.theUserProject = A.local('$projectId');
        if (this.theUserProject == 0) {
            this.getProjectList({ pageSize: 0 });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getSysIpLocationList();
    },
    mounted() {

    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/ipCity/ipCity.vue